var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgClearColor = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6917 17.8523C16.4187 19.7519 14.2775 21 11.8482 21C7.9426 21 4.77706 17.7771 4.7768 13.8005C4.7768 11.9707 5.89962 9.53784 7.28419 7.44475L17.6917 17.8523Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8482 3C13.6161 3 18.9197 9.8237 18.9197 13.8005C18.9196 14.8222 18.7076 15.7929 18.3308 16.6733L8.03503 6.37751C9.4814 4.4378 11.0368 3 11.8482 3Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.99434 6.23929C3.66855 5.9135 3.66855 5.38529 3.99434 5.0595C4.32013 4.7337 4.84835 4.7337 5.17414 5.0595L19.6584 19.5437C19.9842 19.8695 19.9842 20.3977 19.6584 20.7235C19.3326 21.0493 18.8044 21.0493 18.4786 20.7235L3.99434 6.23929Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgClearColor);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/clear-color.bd9d06c93428e3d1a26174659b7030fc.svg";